import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Aesthetic%20fashion%20mood%20board%20flatlay%20with%20neutral%20toned%20clothing%20items%20sneakers%20accessories%20and%20a%20laptop%20scattered%20artistically%20on%20a%20warm%20sand%20colored%20linen%20fabric%20surface%2C%20soft%20golden%20hour%20lighting%20from%20top%20left%20creating%20organic%20shadows%2C%20editorial%20photography%20with%20airy%20minimal%20composition%20and%20subtle%20warmth%2C%20high%20key%20style%20with%20textured%20backdrop&width=1800&height=1200&seq=hero-bg-main-v2-x5y6&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="animate-fade-in-up">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase bg-background-50/90 text-primary-600 rounded-full mb-6">
            {t('hero.badge')}
          </span>
        </div>

        <h1 className="animate-fade-in-up stagger-1 text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
          {t('hero.title')}
        </h1>

        <p className="animate-fade-in-up stagger-2 text-lg md:text-xl font-heading text-white/90 italic mb-4">
          {t('hero.subtitle')}
        </p>

        <p className="animate-fade-in-up stagger-3 text-sm md:text-base text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('hero.description')}
        </p>

        <div className="animate-fade-in-up stagger-4 flex flex-wrap justify-center gap-3 mb-10">
          {[t('hero.feature1'), t('hero.feature2'), t('hero.feature3'), t('hero.feature4')].map((feat) => (
            <span
              key={feat}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs md:text-sm text-white/90 bg-white/10 backdrop-blur-sm rounded-full"
            >
              <i className="ri-check-line text-accent-400 text-sm"></i>
              {feat}
            </span>
          ))}
        </div>

        <div className="animate-fade-in-up stagger-5 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2 shadow-lg shadow-primary-500/25"
          >
            {t('hero.cta')}
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
          >
            buy it now
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}